var render = function render(){var _vm=this,_c=_vm._self._c;return _c('user-viewer',{staticClass:"user-viewer show",attrs:{"online-payable-editable":"","uid":_vm.userID}})
}
var staticRenderFns = []

export { render, staticRenderFns }